import { Link } from "react-router";
import { docsPath } from "./docsNav";

export function DocsInferenceNetworkPage() {
  return (
    <div className="docs-article">
      <p className="docs-eyebrow">Platform</p>
      <div className="docs-title-row">
        <h1 className="docs-page-title">Inference network</h1>
        <span className="badge badge--mock docs-page-status">Preview</span>
      </div>
      <p className="docs-lede">
        Woven Intelligence is an optional, adjacent inference plane that uses ordinary Woven
        identities, sessions, spaces, and grants. Inference remains Preview; managed integration is
        planned for private Pro and Dedicated founder access, not a deployed hosted inference
        service.
      </p>

      <div className="panel notice-panel docs-spatial-notice">
        <p className="page-prose">
          <strong>Planned Preview scope.</strong> Managed provider and tool integration is planned
          for private Pro and Dedicated founder access. These docs do not establish a deployed or
          validated hosted inference service. Lite focuses on realtime relay.
        </p>
      </div>

      <h2 className="docs-heading">How it connects</h2>
      <p className="docs-body">
        In the optional Woven inference subsystem, the coordinator authenticates an AI identity,
        joins a session, subscribes to a space, and spawns an entity through the same bounded
        runtime path as other clients. Requests and results use Woven protocol messages, and the
        identity receives only its configured grants. See{" "}
        <Link to={docsPath("sessions")} className="docs-inline-link">
          Sessions
        </Link>{" "}
        for the authorization scope.
      </p>

      <h2 className="docs-heading">Preview scope</h2>
      <dl className="detail-list">
        <div className="detail-row">
          <dt>Providers</dt>
          <dd>
            The provider interface supports an independently configured model backend. Managed
            provider selection is planned Preview work.
          </dd>
        </div>
        <div className="detail-row">
          <dt>Tools</dt>
          <dd>
            A bounded registry and gateway validate tool identity, version, and freshness before
            invoking a handler. Managed registration and operator controls are planned Preview work.
          </dd>
        </div>
        <div className="detail-row">
          <dt>Isolation</dt>
          <dd>
            The inference plane can be disabled independently of relay behavior. Session, space, and
            channel authorization continue to govern its traffic.
          </dd>
        </div>
      </dl>
    </div>
  );
}
